import { Form, Select } from 'antd'
import React from 'react'

const { Option } = Select

export const GENDERS = {
  male: 'male',
  female: 'female',
  notPresented: 'notPresented'
}

export const GENDERS_LABELS = {
  male: 'Мужской',
  female: 'Женский',
  notPresented: 'Не указан'
}

const GenderFormItem = ({
  label = 'Пол',
  rules = undefined,
  requiredRule = false,
  messageRule = 'Пожалуйста, выберите пол',
  size = 'large',
  placeholder = 'Не указан',
  disabled = false
}) => {
  return (
    <Form.Item
      name={['personalData', 'gender']}
      label={label}
      rules={rules ?? [{ required: requiredRule, message: messageRule }]}
    >
      <Select size={size} placeholder={placeholder} disabled={disabled}>
        {
          Object.keys(GENDERS_LABELS).map(key => <Option key={key} value={key}>{GENDERS_LABELS[key]}</Option>)
        }
      </Select>
    </Form.Item>
  )
}
export default GenderFormItem
